import { defineStore } from 'pinia';
import { readonly, ref, computed } from 'vue';
import {
  type UserSelected,
  type UserInfo,
  type UserPreferences,
} from '~/domains/user';

const useUserStore = defineStore('user', () => {
  const user = ref<UserInfo | null>(null);
  const preferences = ref<UserPreferences | null>(null);

  const showDropship = computed(() => user.value?.canUseDropship);
  const showDep = computed(() => user.value?.functions?.includes('DEP'));
  const selectedCompany = computed(
    () =>
      user.value?.companies?.find(
        (company) => company.id === user.value?.selected?.customerId,
      ) ?? null,
  );
  const isUseGrades = computed(() => user.value?.isUseGrades);
  const currency = computed(() => user.value?.selected?.currency);
  const showPricesWithVat = computed(
    () => user.value?.selected?.showPricesWithVat,
  );
  const selectedLanguage = computed(() => user.value?.selected?.language);

  const setUser = (newUser: UserInfo | null): void => {
    user.value = newUser;
  };

  const setUserSelected = (data?: UserSelected): void => {
    if (user.value === null || data === undefined) return;
    user.value.selected = data;
  };

  const setUserPreferences = (data: UserPreferences): void => {
    preferences.value = data;
  };

  return {
    setUser,
    setUserSelected,
    setUserPreferences,
    user: readonly(user),
    preferences: readonly(preferences),
    showPricesWithVat,
    showDep,
    showDropship,
    selectedCompany,
    selectedLanguage,
    isUseGrades,
    currency,
  };
});

export default useUserStore;
